// ! NOTE : this is the new version of send-to-mobile
import React, { useState, useCallback, useEffect } from 'react'
import * as Yup from 'yup'
import NeoButton from '../../../components/NeoButton/NeoButton'
import NeoLoader from '../../../components/FormComponents/NeoLoader'
import NeoOTP from '../../../components/FormComponents/NeoOTP'
import NeoSuccess from '../../../components/FormComponents/NeoSuccess'
import { useHistory } from 'react-router-dom'
import { Form, Formik } from 'formik'
import NeoInput from '../../../components/NeoInput/NeoInput'
import InputError from '../../../components/InputError/InputError'
import { useTranslation } from 'react-i18next'
import {
  REQUESTS_KEYS,
  VALIDATION_MESSAGES,
  BENEFICIARY_TRANSFER_KEYS,
  SIDENAV_KEYS,
  DEPOSITS_KEYS,
} from '../../../utils/translation-constants'
import SendToMobileService from '../../../services/send-to-mobile.service'
import AccountsService from '../../../services/accounts.service'
import NumberFormat from 'react-number-format'
import LayoutWithAccountCard from '../../../layout/Layout/layout-account-card'
import { carouselCurrentItemSelector } from '../../../selectors'
import AccountDisplay from '../../../components/account-display/account-display'
import { useSelector } from 'react-redux'
import { setAccRefresh } from '../../../actions'

export default function SendToMobile() {
  const [otp, setOtp] = useState('')
  const [stage, setStage] = useState(0)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const history = useHistory()
  const { t } = useTranslation()
  // const accounts = useSelector(accountsSelector)
  const current = useSelector(carouselCurrentItemSelector)
  const [formData, setFormData] = useState({
    mobileNumber: '',
    transferAmount: '',
    remarks: '',
    serviceId: '',
  })
  const [terms, setTerms] = useState('')
  const [wallet, setWalletList] = useState([])
  const [selectedWallet, setSelectedWallet] = useState({})
  const [accountList, setAccountList] = useState([])

  const [serId, setSerId] = useState({})
  const [valid, setValid] = useState('')

  // let list=walletList()
  const [verifyResponse, setVerifyResponse] = useState(false)

  const fetchAccounts = useCallback(async () => {
    const response = await AccountsService.getAllAccounts()
    setAccountList(response.accountSummaryList)
  }, [])

  const getWalletList = useCallback(async () => {
    try {
      const response = await SendToMobileService.walletList()
      setWalletList(response)
      setSerId(response[0])
      setStage(1)
    } catch (err) {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    getWalletList()
  }, [])

  const submitSendToMobile = useCallback(
    async (data) => {
      try {
        setLoading(true)
        const account = current
        setFormData({ ...data, account: account })
        const response = await SendToMobileService.verifyTransfer({
          accountBranch: account.brnCode,
          srcAccCcy: account.currency,
          srcAccount: account.accountNo,
          receiverMobileNo: data.mobileNumber,
          remarks: data.remarks,
          transferAmount: data.transferAmount,
          serviceId: serId.serviceId,
          //customerId: data.customerId,
        })
        // if (response.status === 500) {
        //   setError(response.data)
        //   showModal()
        // } else {
        setVerifyResponse(response)
        setStage(2)
        // }
        setLoading(false)
      } catch (error) {
        setMessage(error.message)
        setLoading(false)
      }
    },
    [accountList, wallet, serId],
  )

  const confirmSendToMobileTransfer = useCallback(async () => {
    try {
      setLoading(true)
      const response = await SendToMobileService.confirmTransfer({
        accountBranch: formData.account.brnCode,
        srcAccCcy: formData.account.currency,
        srcAccount: formData.account.accountNo,
        receiverMobileNo: formData.mobileNumber,
        remarks: formData.remarks,
        transferAmount: formData.transferAmount,
        serviceID: serId.serviceId,
        //customerId: formData.customerId,
        destinationAccount: verifyResponse.destAcc,
        destinationAccountName: verifyResponse.destAccName,
        destinationBranch: verifyResponse.destAccBranch,
        destinationCurrency: verifyResponse.destAccCur,
        otp: verifyResponse.otpEnable ? otp : '0000',
        randomKey: verifyResponse.randomKey,
      })
      // if (response.status == 500) {
      //   setError(response.data)
      //   showModal()
      // } else {
      setMessage(response.message)
      setStage(4)
      setAccRefresh(true)
      // }
      setLoading(false)
    } catch (error) {
      setLoading(false)
      setMessage(error.message)
    }
  }, [otp, formData, accountList, wallet])

  const SchemaSendtoMobile = Yup.object().shape({
    serviceId: Yup.string().required(t(VALIDATION_MESSAGES.SERVICE_ID)),
    mobileNumber: Yup.string()
      .matches(new RegExp(serId?.regexVal), serId?.errorMsg)
      .required(t(VALIDATION_MESSAGES.MOBILE_NUMBER1)),
    // remarks: Yup.string().min(4, 'Minimum 4 Characters').required('Remarks is required'),
    remarks: Yup.string()
      .min(2, t(VALIDATION_MESSAGES.REPORT_VALID))
      .max(40, t(VALIDATION_MESSAGES.REPORT_VALID))
      .required(t(VALIDATION_MESSAGES.REMARK)),
    // customerId: Yup.string().required('Customer Id is required'),
    transferAmount: Yup.string()
      // .matches(/^(\d+|\d{1,3}(,\d{3})*)(\.\d+)?$/, t(VALIDATION_MESSAGES.NUMBERS))
      .required(t(VALIDATION_MESSAGES.AMOUNT)),
  })

  function renderForm() {
    return (
      <div>
        <div className='heading-style'>
          {t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_SUCCESS_KEYS.SEND_TO_WALLET)}
        </div>
        <Formik
          enableReinitialize
          initialValues={formData}
          validationSchema={SchemaSendtoMobile}
          onSubmit={submitSendToMobile}>
          {({ errors, touched, handleChange, setFieldValue }) => (
            <Form>
              <AccountDisplay currentAccountDetail={current} />

              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    mode='select'
                    text={t(SIDENAV_KEYS.SERVICEREQUEST_KEYS.SUBTITLE1)}
                    name='serviceId'
                    onChange={(e) => {
                      const servId = wallet.filter((v) => v.walletName === e.target.value)[0]
                      setSerId(servId)
                      handleChange(e)
                    }}
                    list={wallet}
                    keyValue='walletName'
                  />
                  <InputError text={errors.serviceId} touched={touched.serviceId} />
                </div>
              </div>
              {/* <div className='row'>
                <div className='col-12'>
                  <div className='form-group'>
                    <NeoInput text='Customer ID *' onChange={handleChange} name='customerId' />
                    <InputError touched={touched.customerId} text={errors.customerId} />
                  </div>
                </div>
              </div> */}
              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    mode='amount'
                    text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.AMOUNT)}
                    onChange={(values) => {
                      setFieldValue('transferAmount', values.value)
                    }}
                    name='transferAmount'
                  />
                  <InputError touched={touched.transferAmount} text={errors.transferAmount} />
                </div>
              </div>
              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.RECIVERMOBILENO)}
                    mode='onlyNumber'
                    onChange={(value) => {
                      setFieldValue('mobileNumber', value?.value)
                    }}
                    type='number'
                    name='mobileNumber'
                    //maxLength={9}
                  />
                  <InputError touched={touched.mobileNumber} text={errors.mobileNumber} />
                </div>
              </div>
              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.REMARKS)}
                    minLength={2}
                    maxLength={40}
                    onChange={handleChange}
                    name='remarks'
                  />
                  <InputError touched={touched.remarks} text={errors.remarks} />
                </div>
              </div>

              <div className='mt-3'>
                {loading ? (
                  <NeoLoader />
                ) : (
                  <NeoButton
                    type='button'
                    type={t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_DETAILS_KEYS.SUBMIT)}
                    mode='newDesign'
                    text='Next'
                  />
                )}
              </div>
              <div className='back-cancel-style' onClick={() => history.push('/quick-pay')}>
                {t(SIDENAV_KEYS.TOUCH_ID_KEYS.CANCEL)}
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderConfirmation() {
    return (
      <div className='d-flex flex-column confirmation'>
        <h3>{t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_SUCCESS_KEYS.CONFIRM_WALLET)}</h3>

        <AccountDisplay currentAccountDetail={formData.account} />
        <div>
          <h6 className='label'>
            {t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_CONFIRM_KEYS.TRANSFER_AMOUNT1)}
          </h6>
          <h6 className='value'>
            <NumberFormat
              value={formData.transferAmount}
              displayType={'text'}
              thousandSeparator={true}
              prefix={''}
              fixedDecimalScale={true}
              decimalScale={2}
              allowEmptyFormatting
            />
          </h6>
        </div>
        <div>
          <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_CONFIRM_KEYS.CHARGES)}</h6>
          <h6 className='value'>
            <NumberFormat
              value={verifyResponse.charges}
              displayType={'text'}
              thousandSeparator={true}
              prefix={''}
              fixedDecimalScale={true}
              decimalScale={2}
              allowEmptyFormatting
            />
          </h6>
        </div>
        <div>
          <h6 className='label'>{t(SIDENAV_KEYS.SERVICEREQUEST_KEYS.SUBTITLE)}</h6>
          <h6 className='value'>{formData.serviceId}</h6>
        </div>
        {/* <div>
          <h6 className='label'>Customer ID</h6>
          <h6 className='value'>{formData.customerId}</h6>
        </div> */}
        <div>
          <h6 className='label'>{t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.RECIVERMOBILENO1)}</h6>
          <h6 className='value'>{formData.mobileNumber}</h6>
        </div>
        <div>
          <h6 className='label'>
            {t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.REMARKS1)}
          </h6>
          <h6 className='value'>{formData.remarks}</h6>
        </div>
        <div className='mt-3'>
          {loading ? (
            <NeoLoader />
          ) : (
            <NeoButton
              type='button'
              mode='newDesign'
              text={t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_STATUS_KEYS.CONFIRM)}
              onClick={() => {
                verifyResponse.otpEnable ? setStage(3) : confirmSendToMobileTransfer()
              }}
            />
          )}
        </div>
        <div className='back-cancel-style' onClick={() => setStage(1)}>
          {t(SIDENAV_KEYS.TOUCH_ID_KEYS.BACK)}
        </div>
      </div>
    )
  }

  function renderSwitch() {
    switch (stage) {
      case 0:
        return <NeoLoader />
      case 1:
        return renderForm()
      case 2:
        return renderConfirmation()
      case 3:
        return (
          <NeoOTP
            loading={loading}
            otp={otp}
            setOTP={setOtp}
            onSubmit={confirmSendToMobileTransfer}
          />
        )
      case 4:
        return <NeoSuccess message={message} onClick={() => setStage(1)} />
      default:
        return <NeoLoader />
    }
  }
  return (
    <LayoutWithAccountCard breadCumKey='SEND_TO_MOBILE'>
      <div className='new-design-form-style'>{renderSwitch()}</div>
    </LayoutWithAccountCard>
  )
}
